import CheckIcon from '@mui/icons-material/Check'
import { selectAddress } from 'feature/addresses/redux/addressCreateSelector'
import { SavedAddress } from 'feature/addresses/redux/MyAddresses.api'
import { FC, useEffect, useState } from 'react'
import { useAppSelector } from 'store/hooks'
import { Button } from 'ui'

import styles from './SaveChangesBtn.module.scss'

interface ISaveChangesBtn {
  currentEdit: null | SavedAddress
  saveChangesAddress: (arg0: SavedAddress | null) => void
  text?: string
}

// кнопка для сохранения изменения адреса, или для подтверждения создания нового
export const SaveChangesBtn: FC<ISaveChangesBtn> = ({
  currentEdit,
  saveChangesAddress,
  text,
}) => {
  const { isValid, isDirty } = useAppSelector(selectAddress)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)

  const handlerClick = () => {
    saveChangesAddress(currentEdit)
  }
  useEffect(() => {
    setIsButtonDisabled(!isValid || !isDirty)
  }, [isValid, isDirty])
  return (
    <Button
      startIcon={<CheckIcon />}
      variant='contained'
      onClick={handlerClick}
      type='submit'
      color='primary'
      disabled={isButtonDisabled}
      className={styles.submitButton}
      data-testid='address-save-btn'
    >
      {text ? text : 'Сохранить изменения'}
    </Button>
  )
}
